import { connect } from 'react-redux';
import AddHelper from './addHelper';
import { bindActionCreators } from 'redux';
import {addHelper, listing, byId} from "../../../services/redux/HelperDetails/action";


const mapStateToProps = state => ({
    addDetails: state.HelperDetails.addDetails,
    list: state.HelperDetails.list,
    byIdDetails: state.HelperDetails.byIdDetails,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    addHelper,
    listing,
    byId
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(AddHelper);
